module.exports = __webpack_public_path__ + "static/media/3H.cd9144e9.svg";